module.exports = __webpack_public_path__ + "static/img/index-02.c19be643.png";